import React from 'react'
import { array, node } from 'prop-types'
import { userRoleAdmin, userRoleSuperUser } from '../../../common/constants'
import { getUserRole } from '../../../redux/global'

const UserRolePermission = ({ allowsTo, children }) => {
  const isAllowed = allowsTo.some(allowedUser => allowedUser === getUserRole() || getUserRole() === userRoleAdmin || getUserRole() === userRoleSuperUser)
  if (isAllowed) {
    return (
      <>
        {children}
      </>
    )
  } else {
    return null
  }
}

UserRolePermission.propTypes = {
  allowsTo: array,
  children: node.isRequired
}

export default UserRolePermission
